import styled from "styled-components";
import PropTypes from "prop-types";
import resolveObjPath from "src/utils/resolve-path";

const propTypes = {
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    textAlign: PropTypes.string,
    inactive: PropTypes.bool,
    margin: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    padding: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

const defaultProps = {
    backgroundColor: null,
    color: null,
    width: null,
    height: null,
    inactive: false,
    margin: null,
    padding: null,
    textAlign: null,
};

const Div = styled.div`
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ theme, color }) => color && resolveObjPath(theme, color.split("."))};
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    text-align: ${({ textAlign }) => textAlign};
    margin: ${({ margin }) => margin && margin.join(" ")};
    padding: ${({ padding }) => padding && padding.join(" ")};
    box-sizing: border-box;
    &:hover {
        background-color: ${({ theme, inactive, backgroundColor }) =>
            !inactive &&
            backgroundColor &&
            resolveObjPath(theme, `${backgroundColor}.hover`.split("."))};
    }
`;

Div.propTypes = propTypes;
Div.defaultProps = defaultProps;

export default Div;
